<script>
	import { handleNav } from "$lib/utilities/handleNav";

	import Image from "$lib/components/Image.svelte";
	import Layers from "./Layers.svelte";
	import MarkedContent from "./MarkedContent.svelte";
	import Fa from "svelte-fa";

	export let data;
	export let preview;

	export let action = {};

	$: imageClass = action.imageClass || "w-[100px] rounded";
</script>

{#if action.description}
	<div class="text-center text-xl">
		<MarkedContent markedContent={action.description} />
	</div>
{/if}

{#if action.actionHref}
	<a
		class={action.actionClass}
		onclick={handleNav}
		href={action.actionHref}
		aria-label={action.ariaLabel || action.label}
		style={action.style}
	>
		{#if action.actionImage}
			<Image
				image={action.actionImage}
				{data}
				{preview}
				class={imageClass}
				loading={action.imageLoading}
			/>
		{/if}
		{#if action.actionIcon}
			<Fa icon={action.actionIcon} />
		{/if}
		{#if action.label}
			<MarkedContent markedContent={action.label} />
		{/if}
		<Layers layers={action.actionLayers} styles={action.actionStyles} />
	</a>
{/if}
